var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    width: 48,
    height: 48,
    fill: "#0F90FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 12C16 10.8954 16.9515 10 18.125 10H30.875C32.0485 10 33 10.8954 33 12V36C33 37.1046 32.0485 38 30.875 38H18.125C16.9515 38 16 37.1046 16 36V12ZM18.125 13H30.875V33H18.125V13ZM24.5 36.3333C25.0869 36.3333 25.5625 35.8856 25.5625 35.3333C25.5625 34.7811 25.0869 34.3333 24.5 34.3333C23.9131 34.3333 23.4375 34.7811 23.4375 35.3333C23.4375 35.8856 23.9131 36.3333 24.5 36.3333Z",
    fill: "#0F90FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.955585f25074f73de32f0d24425264d1.svg";
export { ForwardRef as ReactComponent };